<template>
    <main class="container">
        <section>
            <h1>DMC Status</h1>
        </section>
        <section>
            <div class="row">
                <div class="col-10">'{{ error.value }}'
                    <table v-if="!GoConnect.loading.dmc && !error.value">
                        <tbody>
                            <tr v-if="GoConnect.device.dmcIsEnabled !== undefined">
                                <th class="pe-4 py-2">DMC Enabled:</th>
                                <td v-if="GoConnect.device.dmcIsEnabled"><i class="fas fa-check-square pe-2" style="color: var(--bs-success)"></i> Enabled</td>
                                <td v-else class="pr-4"><i class="fas fa-square pe-2" style="color: var(--bs-text-muted)"></i> Disabled</td>
                            </tr>
                            <tr v-if="GoConnect.device.dmcIsConnected !== undefined">
                                <th class="pe-4 py-2">DMC Port Connected:</th>
                                <td v-if="GoConnect.device.dmcIsConnected"><i class="fas fa-check-square pe-2" style="color: var(--bs-success)"></i> Connected</td>
                                <td v-else class="pr-4"><i class="fas fa-exclamation-triangle pe-2" style="color: var(--bs-danger)"></i> Disconnected</td>
                            </tr>
                            <tr v-for="message in GoConnect.device.dmcMessages">
                                <td></td>
                                <td>{{ message }}</td>
                            </tr>
                            <tr>
                                <th class="pe-4 py-2">DMC Status:</th>
                                <td v-if="GoConnect.device.dmcIsRunning"><i class="fas fa-check-square pe-2" style="color: var(--bs-success)"></i> Running</td>
                                <td v-else class="pr-4"><i class="fas fa-exclamation-triangle pe-2" style="color: var(--bs-warning)"></i> Stopped</td>
                            </tr>
                            <tr>
                                <th class="pe-4 py-2">DMC Cache Size: </th>
                                <td>{{ GoConnect.device.dmcCacheSize }} entries</td>
                            </tr>
                        </tbody>
                    </table>
                    <template v-else-if="GoConnect.loading.dmc && !error.value">
                        <div class="d-flex justify-content-center">
                            <div class="spinner-border" role="status" style="width: 6rem; height: 6rem; margin: 1rem;">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div>Error: {{ error }}</div>
                    </template>
                </div>
            </div>
        </section>
    </main>
</template>

<script setup>
import {
    inject, onMounted, onUnmounted, ref,
} from 'vue';

const GoConnect = inject('GoConnect');

let interval = undefined;
let timeout = undefined;
const error = ref('');

onMounted( async () => {
    /*if (GoConnect.device.name === null || GoConnect.device.name.trim() === '') {
        GoConnect.onDisconnect();
    }*/

    timeout = setTimeout(() => {
        console.debug(`Timeout ${GoConnect.loading.dmc}`)
        if(GoConnect.loading.dmc) {
            error.value = 'DMC Status timed out';
        }
        console.debug(error.value);
        console.log(`'${error.value}'`)
    }, 5000);



    GoConnect.sendMessage({type: 'get_dmc_status'});

    interval = setInterval(() => {
        GoConnect.sendMessage({type: 'get_dmc_status'});
    }, 10000);
});

onUnmounted( async () => {
    clearInterval(interval);
    GoConnect.loading.dmc = true;
});
</script>